import { ButtonEmphases } from '@thg-commerce/gravity-elements'

export type FourButtonLinkThemeInterface = {
  buttonEmphasis: ButtonEmphases
}

// TODO: REBUILD-5392: Get buttonEmphasis from Artemis.
//       Add widget page to Artemis to allow configuraiton.
export const FOUR_BUTTON_LINK_THEME: FourButtonLinkThemeInterface = {
  buttonEmphasis: 'medium',
}
